import { render, staticRenderFns } from "./CatOrder.vue?vue&type=template&id=147c49c7&scoped=true"
import script from "./CatOrder.vue?vue&type=script&lang=js"
export * from "./CatOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147c49c7",
  null
  
)

export default component.exports